import { render, staticRenderFns } from "./createJob.vue?vue&type=template&id=89a24616&scoped=true"
import script from "./createJob.vue?vue&type=script&lang=js"
export * from "./createJob.vue?vue&type=script&lang=js"
import style0 from "./createJob.vue?vue&type=style&index=0&id=89a24616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a24616",
  null
  
)

export default component.exports